import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { url: String }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  share(event) {
    const type = event.params.type
    const url = `${this.urlValue}?type=${type}`

    fetch(url)
      .then(r => r.json())
      .then(data => {
        const text = data.text

        if (navigator.share) {
          navigator.share({ text }).catch(() => {})
        } else {
          navigator.clipboard.writeText(text).then(() => {
            const isDark = document.documentElement.classList.contains("dark")
            window.Swal.fire({
              icon: "success",
              text: "Lista copiada para a área de transferência!",
              timer: 2500,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              background: isDark ? "#1f2937" : "#fff",
              color: isDark ? "#f3f4f6" : undefined
            })
          })
        }
      })

    this.menuTarget.classList.add("hidden")
  }
}
